const SET_TIMEZONE_LIST = (state, timezoneList) => {
  state.timezoneList = timezoneList;
};

const SET_CURRENT_TIMEZONE_AREA = (state, area) => {
  state.currentTimezoneArea = area;
};

export default {
  SET_TIMEZONE_LIST,
  SET_CURRENT_TIMEZONE_AREA,
};
